import { useSelectReportData } from '../../hooks/useSelectReportData'
import '../../Report.css'
import { ExperimentItem } from '../ExperimentListItem/ExperimentItem'
import './Page2-experiments.css'

const Page2 = () => {
  const { experimentItems, isNoExperiments } = useSelectReportData()

  if (isNoExperiments) {
    return null
  }

  return (
    <div style={{ padding: '15px 10px 60px 10px' }}>
      <p className='title-bold'>Report highlights</p>
      <p className='subtitle'>Accomplishments</p>
      {experimentItems.map((exItem, i) => {
        return (
          <ExperimentItem
            {...exItem}
            key={i}
          />
        )
      })}
    </div>
  )
}

export default Page2
